import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { RouterProvider } from 'react-router-dom';

import { useAppTheme } from './theme';
import './App.css';
import { SnackbarProvider } from 'notistack';
import Notifications from './containers/Notifications';
import useRouterProvider from './routes';
import useExternalUserLoader from './layouts/AuthLayout/hooks/useExternalUserLoader';
function App() {
  const theme = useAppTheme();
  const router = useRouterProvider();
  useExternalUserLoader();
  useEffect(() => {
    if (typeof window !== 'undefined' && window.parent && window.parent !== window) {
      window.parent.postMessage({ type: 'IFRAME_READY' }, '*');
      
    }
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3}>
        <Notifications />
        <RouterProvider router={router} />
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
